// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-input-group__append, .el-input-group__prepend {\r\n    background-color: #F5F7FA;\r\n    color: #909399;\r\n    vertical-align: middle;\r\n    display: table-cell;\r\n    position: relative;\r\n    border: 1px solid #DCDFE6;\r\n    border-radius: 4px;\r\n    padding: 0 3px;\r\n    width: 1px;\r\n    white-space: nowrap;\n}\r\n", ""]);
// Exports
module.exports = exports;
